module.exports = __webpack_public_path__ + "static/img/26.3aa4696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/26.jpg
// module id = o9yG
// module chunks = 0